<template>
  <Content
    header-image-src="/img/content/img-contents-thumb-care.png"
    :header-title="['유심사 팀에서', '유심사케어 알려드림']"
    date="2026.02.06"
  >
    <p class="typo-1 mt-8 mb-16">
      안녕하세요. 유심사 에디터 에요.<br />
      오늘 다루어 볼 콘텐츠는 유심사케어 에요 🛡️
    </p>
    <p class="typo-1 mb-30">하나부터 열까지 모든 내용을 아티클로 담아봤어요.</p>

    <div class="title-typo-1 bg-yellow mb-16">1. 유심사케어 왜 필요할까?</div>
    <p class="title-typo-2 mb-default">
      여행 중 통신 장애는 ‘불편’이 아니라<br />
      ‘여행 붕괴 리스크’
    </p>
    <p class="typo-1 mb-default">
      유심사를 사랑해 주시는 분들께서는<br />
      이런 경험이 익숙치 않겠지만 그래도 준비해 봤어요.
    </p>

    <p class="typo-1 mb-default">
      대부분의 통신 서비스는 통신 품질 자체에만 집중하고, <b>장애 이후의 고객 경험</b>은 관리하지
      않고 있어요.
    </p>

    <p class="typo-1 mb-16">
      하지만, 실제 여행 현장에서 통신 장애는 아래와 같은 <b>연쇄적 손실</b>을 발생 시키고 있어요.
    </p>

    <table class="mb-30">
      <thead>
        <tr>
          <th style="width: 60px">단계</th>
          <th style="width: 110px">발생 문제</th>
          <th>실제 영향</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1단계</td>
          <td>데이터 연결 불가</td>
          <td>지도, 예약 확인, 호출 서비스 이용 불가</td>
        </tr>
        <tr>
          <td>2단계</td>
          <td>이동 지연</td>
          <td>교통비 증가, 일정 지연</td>
        </tr>
        <tr>
          <td>3단계</td>
          <td>예약 문제</td>
          <td>노쇼, 위약금 발생</td>
        </tr>
        <tr>
          <td>4단계</td>
          <td>일정 붕괴</td>
          <td>여행 만족도 급락, 브랜드 불신</td>
        </tr>
      </tbody>
    </table>

    <Separator class="mb-30" />

    <div class="title-typo-1 bg-yellow mb-16">2. 왜 타사는 케어/서비스를 하지 않는가?</div>
    <p class="typo-1 mb-default">
      다양한 케어 또는 보장 서비스는 대부분 가전 제품에 있지만, 통신처럼 눈에 보이지 않는 무형
      상품은 문제가 발생해도 케어 서비스를 지원하지 않아요.
    </p>

    <p class="title-typo-2 mb-default">기존 eSIM / 유심 시장 구조</p>
    <p class="typo-1 mb-default">
      현재 해외 eSIM · 유심 시장의 대부분의 서비스 구조는 판매 → 개통 → 끝 이에요.
    </p>

    <table class="mb-16 mt-14">
      <thead>
        <tr>
          <th style="width: 110px">구분</th>
          <th>타사 구조</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>판매</td>
          <td>eSIM / 유심 판매</td>
        </tr>
        <tr>
          <td>개통</td>
          <td>매뉴얼 제공</td>
        </tr>
        <tr>
          <td>장애 발생</td>
          <td>고객 책임</td>
        </tr>
        <tr>
          <td>사후 보상</td>
          <td>없음</td>
        </tr>
      </tbody>
    </table>

    <p class="title-typo-2 mb-default">
      타사들이 로밍 보장 케어 서비스를 운영하지 않는 이유는 다음과 같아요.
    </p>
    <ol
      class="typo-1 mb-16"
      style="padding-left: 4px"
    >
      <div>1. 원가 부담 증가</div>
      <div>2. 운영 복잡도 증가</div>
      <div>3. CS 리스크 증가</div>
      <div>4. 정산·증빙 관리 부담</div>
    </ol>

    <p class="typo-1 mb-30">즉, 비용과 운영 부담 때문에 고객 경험 보호를 포기한 구조에요.</p>

    <Separator class="mb-30" />

    <div class="title-typo-1 bg-yellow mb-16">3. 통신 장애는 왜 이렇게 치명적인가?</div>
    <p class="typo-1 mb-default">
      한국에서도 일부 음영 지역에 있을 경우 통신이 잘 되지 않아 통신사 고객센터로 문의해 보신 경험이
      있으시죠?
    </p>

    <p class="title-typo-2 mb-default">통신 장애는 '대체 수단 비용'을 강제 발생시켜요.</p>
    <p class="typo-1 mb-default">
      통신 장애는 단순한 불편이 아니라, 즉각적인 '추가 지출'을 만들어 내고 있어요.
    </p>

    <table class="mb-16">
      <thead>
        <tr>
          <th style="width: 120px">상황</th>
          <th>발생 비용 (원화 기준)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>대체 유심 구매</td>
          <td>1~3만원</td>
        </tr>
        <tr>
          <td>포켓와이파이 렌탈</td>
          <td>1~2만원/일</td>
        </tr>
        <tr>
          <td>택시 이동</td>
          <td>2~10만원</td>
        </tr>
        <tr>
          <td>액티비티 위약금</td>
          <td>5~20만원</td>
        </tr>
      </tbody>
    </table>

    <p class="typo-1 mb-30">평균적으로 통신 장애가 발생하면 3만~15만원의 추가 비용 발생해요.</p>

    <Separator class="mb-30" />

    <div class="title-typo-1 bg-yellow mb-16">4. 왜 고객 불만이 반복되는가?</div>
    <p class="typo-1 mb-default">
      한국에서도 잘 되지 않는 경우가 있지만 현지로 출국한 분들은 더욱 고객 불만 부분에서 예민할 수
      밖에 없어요.
    </p>

    <table class="mb-16">
      <thead>
        <tr>
          <th style="width: 110px">영역</th>
          <th>기존 서비스</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>책임 구조</td>
          <td>장애 발생 시 고객 책임</td>
        </tr>
        <tr>
          <td>보상 체계</td>
          <td>없음</td>
        </tr>
        <tr>
          <td>대응 방식</td>
          <td>고객 직접 해결</td>
        </tr>
        <tr>
          <td>경험 결과</td>
          <td>불만, 브랜드 불신, 재구매 감소</td>
        </tr>
      </tbody>
    </table>

    <p class="title-typo-2 mb-default">핵심 문제</p>
    <p class="typo-1 mb-30">
      "통신 장애는 불가항력인데, 그 리스크를 전부 고객에게 전가하고 있어요."
    </p>

    <Separator class="mb-30" />

    <div class="title-typo-1 bg-yellow mb-16">5. 유심사케어의 차별 구조 – 무엇이 다른가?</div>

    <div class="info-box mb-default">
      <div class="info-icon">
        <span style="font-size: 16px">💡</span>
      </div>
      <div class="info-text">
        드디어, 출시된 유심사케어 이 부분이 가장 중요해요. 여기서부터 집중해야 돼요 👀
      </div>
    </div>

    <p class="title-typo-2 mb-default">기존 구조 vs 유심사 구조 비교</p>

    <table
      class="mb-16"
      style="table-layout: fixed"
    >
      <thead>
        <tr>
          <th style="width: 80px">구분</th>
          <th style="width: 50%">
            <span style="display: inline-flex; align-items: center; gap: 4px">
              유심사의 유심사케어
              <IUsdgShieldUsimsacare
                style="width: 12px; height: 12px"
                filled
              />
            </span>
          </th>
          <th style="width: 50%">기존 업체</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>장애 대응</td>
          <td>유심사 <span style="color: #0066ff">비용 보전</span></td>
          <td>고객 자력 해결</td>
        </tr>
        <tr>
          <td>비용 부담</td>
          <td><span style="color: #0066ff">최대 30만원 보상</span><br />(구매 상품별 상이)</td>
          <td>전액 고객</td>
        </tr>
        <tr>
          <td>심리 경험</td>
          <td style="color: #0066ff">안정, 신뢰</td>
          <td>불안, 분노</td>
        </tr>
        <tr>
          <td>브랜드 인식</td>
          <td style="color: #0066ff">여행 파트너</td>
          <td>판매자</td>
        </tr>
      </tbody>
    </table>

    <p class="typo-1 mb-30">
      유심사는 단순 판매 중심이 아닌, 사용자 경험 보호를 핵심가치로 두고 있어요.
    </p>

    <Separator class="mb-30" />

    <div class="title-typo-1 bg-yellow mb-16">6. 타사 대비 차별성 비교표</div>

    <div class="info-box mb-default">
      <div class="info-icon">
        <span style="font-size: 16px">💡</span>
      </div>
      <div class="info-text">
        정말 모든 보상 이나 추가 비용이 들지 않고, 유심사케어 서비스가 적용돼요
      </div>
    </div>

    <p class="title-typo-2 mb-default">기존 구조 vs 유심사 구조 비교</p>

    <table
      class="mb-default"
      style="table-layout: fixed"
    >
      <thead>
        <tr>
          <th style="width: 80px">항목</th>
          <th style="text-align: center; width: calc((100% - 80px) / 4)">유심사</th>
          <th style="text-align: center; width: calc((100% - 80px) / 4)">통신사</th>
          <th style="text-align: center; width: calc((100% - 80px) / 4)">A사</th>
          <th style="text-align: center; width: calc((100% - 80px) / 4)">B사</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>통신 장애<br />보상</td>
          <td style="text-align: center; color: #0066ff; font-weight: 500">○</td>
          <td style="text-align: center">✕</td>
          <td style="text-align: center">✕</td>
          <td style="text-align: center">✕</td>
        </tr>
        <tr>
          <td>교통비 보상</td>
          <td style="text-align: center; color: #0066ff; font-weight: 500">○</td>
          <td style="text-align: center">✕</td>
          <td style="text-align: center">✕</td>
          <td style="text-align: center">✕</td>
        </tr>
        <tr>
          <td>숙박/여가<br />보상</td>
          <td style="text-align: center; color: #0066ff; font-weight: 500">○</td>
          <td style="text-align: center">✕</td>
          <td style="text-align: center">✕</td>
          <td style="text-align: center">✕</td>
        </tr>
        <tr>
          <td>상품별 자동 적용</td>
          <td style="text-align: center; color: #0066ff; font-weight: 500">○</td>
          <td style="text-align: center">✕</td>
          <td style="text-align: center">✕</td>
          <td style="text-align: center">✕</td>
        </tr>
        <tr>
          <td>추가 비용<br />없음</td>
          <td style="text-align: center; color: #0066ff; font-weight: 500">○</td>
          <td style="text-align: center">△</td>
          <td style="text-align: center">△</td>
          <td style="text-align: center">△</td>
        </tr>
      </tbody>
    </table>

    <p class="typo-1 mb-default">통신 시장 내 유일한 로밍을 위한 케어 서비스가 운영 중에 있어요.</p>
    <p class="typo-3 mb-30">*통신사별 상담사별 대응에 따라 비용 처리 여부 상이</p>

    <Separator class="mb-30" />

    <div class="title-typo-1 bg-yellow mb-16">7. 왜 이게 필요한가?</div>
    <p class="typo-1 mb-default">
      유심사케어는 단순한 보상 서비스가 아니라, 여행 통신 서비스의 패러다임 전환이에요.
    </p>
    <p
      class="typo-1"
      style="margin-bottom: -16px"
    >
      현지에서 데이터가 안되면 어쩌지? 라는 걱정은 이제 그만, 이제 마음 편하게 해외로 출국하실 수
      있어요.
    </p>
  </Content>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})
useHead({
  title: '유심사 팀에서 유심사케어 알려드림',
  meta: [
    {
      hid: 'description',
      name: 'description'
    }
  ]
})
</script>
